export default {
  // 汎用
  SUCCESS: 'OK', // API通信成功時のメッセージ
  TRANSITION: '入力内容が破棄されますが、ページを離れてもよろしいですか？', // ページ遷移時の確認メッセージ
  GET_MESSAGE: '呼出に成功しました', // 呼出成功時のメッセージ
  DELETE_MESSAGE: '削除が完了しました', // 削除完了のメッセージ
  REGISTER_MESSAGE: '登録が完了しました', // 登録完了のメッセージ
  UPDATE_MESSAGE: '更新が完了しました', // 更新完了のメッセージ
  SUCCESS_STAMPING: '打刻しました', // 打刻の成功メッセージ
  ROUTE_ERROR: 'UserError', // vue-routerでエラー画面に遷移する際のname

  // エラーメッセージ
  REQUIRED: '{_field_}を入力してください', // 必須項目のメッセージ
  NUMERIC: '{_field_}を数字で入力してください', // 数字のみのメッセージ
  MAX: '{_field_}は{length}文字以内で入力してください', // 最大値のメッセージ
  EMPLOYEE_ERROR: '{_field_}は全半角数字20文字以内で入力してください', // 社員番号のメッセージ
  EMAIL_ERROR: '{_field_}は有効なメールアドレスを入力してください（半角英数字、記号は-._のみ使用可能）', // メールアドレスのメッセージ
  HOLIDAY_ERROR: '{_field_}は数字を入力してください（-99.9～99.9の範囲）', // 有給、代休日数のメッセージ
  NUM_SYMBOL: '{_field_}は入力例のように、半角数字と記号を用いて入力してください', // 半角数字と記号のメッセージ
  NUM_MAX: '{_field_}は半角数字{num}文字以内で入力してください',// 半角数字と最大値のメッセージ
  FULL_WIDTH: '{_field_}は半角英字、または日本語文字（ひらがな、カタカナ、漢字）{num}文字以内で入力してください',// 全角のメッセージ
  ADDRESS_ERROR: '{_field_}は全角英数字記号、半角カタカナは使用しないで入力してください', // 住所のメッセージ
  TELEPHONE_ERROR: '{_field_}は半角数字10文字以上、15文字以内で市外局番から入力してください', // 電話番号のメッセージ
  SAME: '{_field_}は{str}と同じ値を入力してください', // 同値チェックのメッセージ
  PASSWORD_ERROR: '{_field_}は英数字混在で8文字以上20文字以下で入力してください。記号の入力も可能です', // パスワードのメッセージ
  SELECT: '{_field_}を選択してください', // 必須セレクトボックスのメッセージ
  NORMAL_ERROR: 'エラーが発生しました', // 汎用のエラーメッセージ
  MAIL_ERROR: 'メールの送信に失敗しました。メールアドレスの入力誤り、未登録などが考えられます。', // メール送信エラーメッセージ
  UPDATE_ERROR: '更新時にエラーが発生しました', // 更新のエラーメッセージ
  REGISTER_ERROR: '登録時にエラーが発生しました', // 登録のエラーメッセージ
  APPLY_ERROR: '申請に失敗しました', // 申請時のメッセージ
  EMPTY: 'データが見つかりませんでした', // 検索時にデータがないときのメッセージ
  EMPTY_REQUEST: '全て承認済みです', // 承認申請一覧および承認待ち一覧メッセージ
  MAIL_DUPLICATED_ERROR: 'ご入力頂いたメールアドレスは使用できません。', // ユーザ登録/更新の重複メッセージ
  HALF_WIDTH_LIMIT_DECIMAL2_ERROR: '{_field_}は半角数字のみで、小数点以下は最大で2桁まで入力できます。', // 小数点第2位まで入力可能のメッセージ
  HOUR_MINUTE_ERROR: '00:00〜23:59の形式で入力してください。', // 一日の時間範囲内に収まらない値のときのメッセージ
  SYSTEM_ERROR: 'システムエラーです。管理者に問い合わせてください。', // システムエラーのメッセージ
  SYSTEM_COMMUNICATION_ERROR: 'システム通信エラーです。管理者に問い合わせてください。', // システム通信エラーのメッセージ

  //呼出時の年のプルダウンメニュー
  YEAR_OPTION : [
    { id: "2021", name: "2021年" },
    { id: "2022", name: "2022年" },
    { id: "2023", name: "2023年" },
    { id: "2024", name: "2024年" },
    { id: "2025", name: "2025年" },
    { id: "2026", name: "2026年" },
    { id: "2027", name: "2027年" },
    { id: "2028", name: "2028年" },
    { id: "2029", name: "2029年" },
    { id: "2030", name: "2030年" }
  ],
  //呼出時の月のプルダウンメニュー
  MONTH_OPTION : [
    { id: "1", name: "1月" },
    { id: "2", name: "2月" },
    { id: "3", name: "3月" },
    { id: "4", name: "4月" },
    { id: "5", name: "5月" },
    { id: "6", name: "6月" },
    { id: "7", name: "7月" },
    { id: "8", name: "8月" },
    { id: "9", name: "9月" },
    { id: "10", name: "10月" },
    { id: "11", name: "11月" },
    { id: "12", name: "12月" }
  ],

  // 提出物状態
  UNSUBMITTED:      '未申請',   // 未申請
  APPLY:            '申請',     // 申請
  APPROVAL_PENDING: '承認待ち', // 承認待ち
  APPROVAL:         '承認済み', // 承認
  REJECT:           '差戻',     // 却下

  // プロジェクト管理関連（一部の値は他に流用）
  ROUTE_PROJECT_LIST: 'プロジェクト管理', // プロジェクト管理画面のパス
  ROUTE_PROJECT_INFO: 'プロジェクト詳細', // プロジェクト詳細画面のパス
  ROUTE_PROJECT_REGISTER: 'プロジェクト登録', // プロジェクト新規登録画面のパス
  ROUTE_PROJECT_UPDATE: 'プロジェクト更新', // プロジェクト更新画面のパス
  ID: 'id', // プロジェクトIDやその他ID
  USER_ID: 'user_id', // ユーザID
  NAME: 'name', // プロジェクト名や氏名
  START_TIME: 'start_time', // 始業時刻
  END_TIME: 'end_time', // 終了時刻
  BREAK_TIME: 'break_time', // 休憩時間
  NIGHT_REST: 'night_rest', // 夜勤休憩
  BASIC_START_TIME: 'basic_start_time', // (基準)始業時刻
  BASIC_END_TIME: 'basic_end_time', // (基準)終了時刻
  BASIC_BREAK_TIME: 'basic_break_time', // (基準)休憩時間
  PRE_BUFFER: 'pre_buffer', // 始業前バッファ
  POST_BUFFER: 'post_buffer', // 定時後バッファ
  WORK_TIME_UNIT: 'work_time_unit', // 勤務時間の最小単位
  WORK_BASIC: 'work_basic', // 規定定時間
  POST_WORK_BREAK_FLG: 'post_work_break_flg', // 定時後休憩フラグ
  STATUS: 'status', // 承認状態
  COMPANY_ID: 'company_id', // 顧客会社ID
  STAFF_NAME: 'staff_name',// 顧客会社担当者
  OWN_STAFF_NAME: 'user_id', // 自社管理者
  APPROVER_FLG: 'approver_flg', //承認者フラグ
  DELETED_FLG: 'deleted_flg', // 削除フラグ
  REMAIN: 0, // 表示する場合の削除フラグの値
  DELETE: 1, // 非表示の場合の削除フラグの値
  ERROR_500: 500, // エラー500
  ERROR_409: 409, // エラー409
  AFFILIATION_COUNT_ERROR: "プロジェクトを設定中の方がいます。",

  // 集計関連
  ROUTE_TOTAL_LIST: '月次集計', // 月次集計画面のパス

  // クライアント管理関連（一部の値は他に流用）
  ROUTE_CLIENT_LIST: 'クライアント管理', // クライアント管理画面のパス
  ROUTE_CLIENT_INFO: 'クライアント詳細', // クライアント詳細画面のパス
  ROUTE_CLIENT_REGISTER: 'クライアント登録', // クライアント登録画面のパス
  ROUTE_CLIENT_UPDATE: 'クライアント更新', // クライアント更新画面のパス
  COMPANY_NAME: 'company_name', //取引先企業名
  USANCE: 'usance', // 支払い期日

  // 設定
  ROUTE_SETTING: '設定',
  ROUTE_SETTING_UPDATE: '設定更新',
  
  // 業務報告関連
  ROUTE_REPORT_LIST: '業務報告一覧', // 業務報告一覧画面のパス
  ROUTE_REPORT_INFO: '業務報告詳細', // 業務報告詳細画面のパス
  RROUTE_REPORT_REGISTER: '業務報告登録', // 業務報告登録画面のパス
  RROUTE_REPORT_EDIT: '業務報告修正', // 業務報告修正画面のパス

  // 勤務表関連
  ROUTE_ROSTER_LIST: '勤務表一覧', // 勤務表一覧画面のパス
  ROUTE_ROSTER_INFO: '勤務表詳細', // 勤務表詳細画面のパス
  RROUTE_ROSTER_REGISTER: '勤務表登録', // 勤務表登録画面のパス
  RROUTE_ROSTER_EDIT: '勤務表修正', // 録勤務表修正画面のパス
  BASE_TIME_MIN: 'base_time_min', // 基準時間(下限)
  BASE_TIME_MAX: 'base_time_max', // 基準時間(上限)
  DATE: 'date', // 日付
  ATTENDANCE1: 'attendance_id1', // 勤怠1
  FULLTIME: 1, // 常勤
  // STAGGERED_WORK: 2,  時差出勤
  MORNING_WORK: 3, // 午前出勤
  SHIFT: 4, // シフト
  HOLIDAY: 5, // 休日
  PAID: 6, // 有給
  MORNING_PAID: 7, // 午前有給
  SUBSTITUTE: 8, // 代休
  MORNING_SUBSTITUTE: 9, // 午前代休
  DEDUCTION: 10, // 欠勤
  // MORNING_DEDUCTION: 11,  午前欠勤
  SPECIAL_HOLIDAY: 12, // 特休有給
  ATTENDANCE2: 'attendance_id2', // 勤怠2
  AFTERNOON_WORK: 13, // 午後出勤
  AFTERNOON_PAID: 14, // 午後有給
  AFTERNOON_SUBSTITUTE: 15, // 午後代休
  EARLY_MORNING: 16, // 早出出勤
  // AFTERNOON_DEDUCTION: 16,  午後欠勤
  UPDATED_AT:'updated_at', //更新日時
  USER_NAME:'user_name', // 更新者
  PROJECT_ID:'project_id', // プロジェクトID
  PROJECT_NAME:'project_name', // プロジェクト名
  REMARKS: 'remarks', // 備考・作業内容
  TARGET_DATE: 'target_date', // 対象日
  LEAVE_EARLY: 'sum_leave_early', // 早退数
  LATE: 'sum_late', // 遅刻数
  WORKING_DAYS: 'working_days', // 週稼働日数
  PAID_DAYS_USED: 'paid_days_used', // 今期有休消化日数
  PAID_DAYS_ADD: 'paid_days_add', // 有給付与月
  PAID_PRE: 'paid_holiday_pre', // 前月残有給
  PAID_ADDED: 'paid_holiday_added', // 今月発生有給
  PAID_USED: 'paid_holiday_used', // 今月消化有給
  PAID_REMAIN: 'paid_holiday_remain', // 今月残有給
  SUBSTITUTE_PRE: 'substitute_holiday_pre', // 前月残代休
  SUBSTITUTE_ADDED: 'substitute_holiday_added', // 今月発生代休
  SUBSTITUTE_USED: 'substitute_holiday_used', // 今月消化代休
  SUBSTITUTE_REMAIN: 'substitute_holiday_remain', // 今月残代休
  DEFINED_DAY: 'defined_attendance_day', // 規定勤務日数
  SUM_DAY: 'sum_attendance_day', // 実務日数
  DEFINED_TIME: 'defined_work_time', // 規定勤務時間
  SUM_TIME: 'sum_work_time', // 実務時間
  SUM_OVER: 'sum_over_time', // 時間外時間
  SUM_DEDUCTION: 'sum_deduction_time', // 欠勤時間
  SUM_NIGHT: 'sum_night_time', // 夜勤時間
  SUM_HOLIDAY: 'sum_holiday_time', // 法定休日時間

  // 経費関連
  ROUTE_EXPENSE_LIST: '経費精算', // 経費精算(仮払申請)画面のパス
  ROUTE_EXPENSE_MASTERINFO: '経費精算詳細(管理者)', // 経費精算(仮払申請)詳細画面のパス
  ROUTE_EXPENSE_INFO: '経費精算詳細', // 経費精算(仮払申請)詳細画面のパス
  ROUTE_EXPENSE_REGISTER: '経費精算登録', // 経費精算(仮払申請)登録画面のパス
  RROUTE_EXPENSE_EDIT: '勤務表修正', // 経費精算(仮払申請)修正画面のパス
  TRANSPORT_ID: 1, // 申請区分が交通費の場合の数値
  EXPENSE_ID: 2, // 申請区分が経費の場合の数値
  STAY_ID: 3, // 申請区分が経費の場合の数値
  COMMUTE_ID: 4, //申請区分が通勤費の場合の数値
  TRANSPORT: '出張交通費', // 申請区分が出張交通費の場合の文字列
  EXPENSE: '経費', // 申請区分が経費の場合の文字列
  STAY: '宿泊費', // 申請区分が宿泊費の場合の文字列
  COMMUTE: '通勤費', //申請区分が通勤費の場合の文字列
  TOTAL_EXPENSE: 'total_expense', // 経費小計
  TOTAL_TEMPORARY: 'total_temporary', // 仮払小計
  TOTAL_PAYMENT: 'total_payment', // 合計支払額
  TARGET_YEAR_MONTH: 'target_year_month', // 対象年月
  REQUEST_TYPE: 'request_type', // 申請区分
  ORIGIN: 'origin', // 発地
  DESTINATION: 'destination', // 着地
  TYPE_DETAILS: 'type_details', // 便名・種別・地名
  AMOUNT: 'amount', // 金額
  PURPOSE: 'purpose', // 用途


  // 通勤費関連
  ROUTE_TRAVEL_COST_MASTER_LIST: '通勤費精算', // 通勤費精算一覧(管理者)画面のパス
  ROUTE_TRAVELCOST_LIST: '通勤費精算一覧', // 通勤費精算一覧画面のパス
  ROUTE_TRAVEL_COST_MASTER_INFO: '通勤費精算詳細(管理者)', // 通勤費精算詳細(管理者)画面のパス
  ROUTE_TRAVELCOST_INFO: '通勤費精算請詳細', // 通勤費精算詳細画面のパス
  ROUTE_TRAVELCOST_REGISTER: '通勤費精算登録', // 通勤費精算登録画面のパス
  ROUTE_TRAVELCOST_EDIT: '通勤費精算修正', // 通勤費精算修正画面のパス
  
  // 休暇申請関連
  ROUTE_PAIDANDSUDSTITUTE_LIST: '休暇申請', // 有給・代休申請一覧画面のパス
  ROUTE_PAIDANDSUDSTITUTE_MASTERLIST: '休暇申請一覧', // 有給・代休申請一覧(管理者)画面のパス
  ROUTE_PAIDANDSUDSTITUTE_MASTERINFO: '休暇申請詳細(管理者)', // 休暇申請詳細(管理者)画面のパス
  ROUTE_PAIDANDSUDSTITUTE_INFO: '休暇申請詳細', // 有給・代休管理詳細画面のパス
  ROUTE_PAIDANDSUDSTITUTE_REGISTER: '休暇申請作成', // 有給・代休管理登録画面のパス
  ROUTE_PAIDANDSUDSTITUTE_EDIT: '休暇申請修正', // 有給・代休管理修正画面のパス
  PAID_ID: 1, // 休暇種別が有給の場合の数値
  SUBSTITUTE_ID: 2, // 休暇種別が代休の場合の数値
  SPECIAL_ID: 3, // 休暇種別が特休の場合の数値
  ABSENT_ID: 4, // 休暇種別がその他欠勤の場合の数値
  
  PAID_NAME: '有給', // 休暇種別が有給の場合の文字列
  SUBSTITUTE_NAME: '代休', // 休暇種別が代休の場合の文字列
  SPECIAL: '特休', // 休暇種別が特休の場合の文字列
  ABSENT: 'その他欠勤', // 休暇種別がその他欠勤の場合の文字列
  ALLDAY_ID: 1, // 時間帯が終日の場合の数値
  MORNING_ID: 2, // 時間帯が午前の場合の数値
  AFTERNOON_ID: 3, // 時間帯が午後の場合の数値
  ALLDAY: '終日', // 時間帯が終日の場合の文字列
  MORNING: '午前', // 時間帯が午前の場合の文字列
  AFTERNOON: '午後', // 時間帯が午後の場合の文字列
  START_HOLIDAY: 'start_holiday', // 休暇開始日時
  END_HOLIDAY: 'end_holiday', // 休暇終了日時
  HOLIDAY_TYPE: 'holiday_type', // 休暇種別
  HOLIDAY_REASON: 'holiday_reason', // 休暇種別
  DATE_MIN: '1900-01-01',//最小の年月日
  DATE_MAX: '2100-12-31',//最大の年月日
  APPROVAL_TYPE: 'approval_type', // 承認済区分
  NOT_SELECTED_ID: '0', // 未選択の場合の数値
  MANAGER_APPROVAL_ID: '1', // 当上長承認済の数値
  SUPERVISOR_APPROVAL_ID: '2', // 現場上長承認済の数値
  BOTH_APPROVAL_ID: '3', // 当上長および現場上長承認済の数値
  MANAGER_APPROVAL: 'manager_approval', // 当上長承認済の場合の文字列
  SUPERVISOR_APPROVAL: 'supervisor_approval', // 現場上長承認済の場合の文字列

  // 時間外申請関連
  ROUTE_OVERTIMES_LIST: '予定外時間外報告', // 時間外管理画面のパス
  ROUTE_OVERTIMES_MASTERINFO: '予定外時間外報告詳細(管理者)', // 時間外申請詳細(管理者)画面のパス
  ROUTE_OVERTIMES_INFO: '予定外時間外報告詳細', // 時間外管理詳細画面のパス
  ROUTE_OVERTIMES_REGISTER: '予定外時間外報告作成', // 時間外管理登録画面のパス
  ROUTE_OVERTIMES_EDIT: '予定外時間外報告修正', // 時間外管理修正画面のパス
  
  // 休日出勤申請関連
  ROUTE_HOLIDAYWORKS_MASTERLIST: '休日出勤報告(管理者)', // 休日出勤申請一覧(管理者)画面のパス
  ROUTE_HOLIDAYWORKS_LIST: '休日出勤報告', // 休日出勤管理画面のパス
  ROUTE_HOLIDAYWORKS_MASTERINFO: '休日出勤報告詳細(管理者)', // 休日出勤申請詳細(管理者)画面のパス
  ROUTE_HOLIDAYWORKS_INFO: '休日出勤報告詳細', // 休日出勤管理詳細画面のパス
  ROUTE_HOLIDAYWORKS_REGISTER: '休日出勤報告作成', // 休日出勤管理登録画面のパス
  ROUTE_HOLIDAYWORKS_EDIT: '休日出勤報告修正', // 休日出勤管理修正画面のパス

  // ユーザ管理関連
  ACCOUNT_ID: 'account_id', // アカウントID
  EMPLOYEE_ID: 'employee_id', // 社員番号
  SLACK_ID: 'slack_id', //Slack ID
  PAID_DAYS: 'paid_days', // 有給日数
  COMP_DAYS: 'comp_days', // 代休日数
  FIXED_OVER_TIME: 'fixed_over_time', // 固定内残業
  TELEPHONE: 'telephone', // 電話番号
  ADDRESS: 'address', // 住所
  EMAIL: 'email', // E-Mail
  PASSWORD: 'password', // パスワード
  HIRE_DATE: 'hire_date', // 入社日
  DEPARTMENT_ID: 'department_id', // 所属部署
  AUTHORITY_ID: 'authority_id', // ユーザ種別
  ROUTE_LIST: 'ユーザ管理', // ユーザ管理画面への相対パス
  ROUTE_INFO: 'ユーザ詳細', // vue-routerでユーザ詳細に遷移する際のname
  REGISTER_TOP: 'ユーザ登録', // ユーザ登録画面上部への相対パス
  UPDATE_TOP: 'ユーザ更新', // vue-routerでユーザ更新に遷移する際のname
  ASTERISK: '*', // アスタリスク（パスワード表示用固定値）
  // 部署管理関連
  DEPARTMENT_ROUTE_LIST: '部署管理', // 部署管理画面のパス
  DEPARTMENT_ROUTE_INFO: '部署詳細', // 部署詳細画面のパス
  DEPARTMENT_ROUTE_REGISTER: '部署登録', // 部署新規登録画面のパス
  DEPARTMENT_ROUTE_UPDATE: '部署更新', // 部署更新画面のパス

  // 部署画面で既存コードがこちらの名前を参照している場合の互換用
  DEPARTMENT_LIST_TOP: '部署管理',
  DEPARTMENT_INFO_TOP: '部署詳細',
  DEPARTMENT_REGISTER_TOP: '部署登録',
  DEPARTMENT_UPDATE_TOP: '部署更新',
  // 正規表現
  TIME_REGEX: /^\d{2}:\d{2}$/, // 時間
  FULL_NUM_REGEX: /^[０-９0-9]*$/, // 全半角数字
  HALF_NUM_REGEX: /^[0-9]*$/, // 半角数字
  DECIMAL_REGEX: /^-?\d{1,2}\.\d{1}$/, // -99.9～99.9までの半角数字
  HOLIDAY_REGEX: /^-?\d{1,2}$/, // 半角数字1桁～2桁まで、-は付かなくてもいい
  HALF_WIDTH_DECIMAL_REGEX2: /^[0-9]*\.?[0-9]{0,2}$/, // 半角数字かつ小数点以下二桁まで
  DATE_REGEX: /^\d{1,2}\/\d{1,2}$/, //日付（例：09/28）
  BASE_TIME_REGEX: /^\d{1,3}-\d{1,3}$/, // 業務報告書の基準時間（例：150-200）
  WORK_TIME_REGEX: /^\d{1,3}:\d{2}$/, // 業務報告書の勤務時間等（例：150:00）
  FULL_WIDTH_REGEX: /[０-９Ａ-Ｚａ-ｚ！-／：-＠［-｀｛-～、-〜”’・ー￥]+/g, // 全角英数記号
  HALF_KATAKANA_REGEX: /[ｦ-ﾟ]/, // 半角カタカナ
  NOT_HALF_REGEX: /^[^\x20-\x7e]*$/, // 半角文字以外
  USER_NAME_PATTEN_REGEX: /^[a-zA-Z\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\s]*$/, // 半角英字、ひらがな、カタカナ、漢字、空白
  TELEPHONE_REGEX: /^0\d{9,14}$/, // 電話番号ハイフンなし（例：0801112222）
  PASSWORD_REGEX: /^(?=.*[0-9])(?=.*[a-zA-Z])[!-~]{8,20}$/i, // パスワード（半角英数字混在8文字以上20文字以下）
  EMAIL_REGEX: /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]\.)+[a-zA-Z]{2,}$/ // 半角英数字、記号は-._のみ使用可能なメールアドレス形式
}
